module.exports = __webpack_public_path__ + "media/images/favicon-65178db36ee7991211f2896df402a7aa.ico";